import React, { useEffect, useReducer, useState } from "react";
import DashboardContainer from "../../components/dashboard-container";
import { customerService } from "../../utils/services/customerService";
import { CircularProgress, Box } from "@mui/material";
import CustomerList from "../../components/customer-list";
import CustomPagination from "../../components/pagination";
import CustomerModal from "../../components/customer-modal";
import buildQuery from "../../utils/query-builder";
import { customerFilterInitialState } from "../../utils/filter-config";

function filterReducer(state, action) {
  switch (action.type) {
    case "SET_FILTER":
      return {
        ...state,
        columns: state.columns.map((x) =>
          x?.key === action?.payload?.key ? { ...x, ...action.payload } : x,
        ),
      };
    case "UPDATE_LIMIT":
      return { ...state, limit: action.payload };
    default:
      return state;
  }
}

export default function Customer() {
  const [filterData, dispatch] = useReducer(
    filterReducer,
    customerFilterInitialState,
  );
  const [openModal, setOpenModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [dataCount, setDataCount] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const clientId = localStorage.getItem("client_id");

  const fetchCustomers = async () => {
    setLoading(true);
    try {
      const response = await customerService.fetch(
        searchValue,
        clientId,
        buildQuery(filterData, page),
      );
      setCustomers(response?.data || []);
      setDataCount(response?.total || 0);
    } catch (error) {
      console.error("Fetch customers failed:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCustomers();
  }, [page, filterData, searchValue]);

  const handleFilterChange = (newFilter) => {
    dispatch({ type: "SET_FILTER", payload: newFilter });
    setPage(0);
  };

  return (
    <>
      <DashboardContainer
        searchBarPlaceholder="Search by Customer Name"
        onChangeFilter={handleFilterChange}
        filterData={filterData}
        fields={filterData.columns}
        hideFilterClient
        onSearchData={(x) => {
          setSearchValue(x);
          setPage(0);
        }}
        onClickAddButton={() => setOpenModal(true)}
        hideUploadButton={true}
        header="Customer List"
        title="+ Add Customer"
        onClickRefresh={clientId ? null : () => fetchCustomers()}
        hideAddButton={!!clientId}
      >
        <CustomerModal
          selectedCustomer={selectedCustomer}
          handleClose={() => {
            setOpenModal(false);
            setSelectedCustomer(null);
          }}
          open={openModal}
          onAddData={fetchCustomers}
        />

        {loading && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0,0,0,0.5)",
              zIndex: 9999,
              color: "white",
            }}
          >
            <CircularProgress color="inherit" />
          </Box>
        )}

        <CustomerList
          data={customers}
          onEditData={(customer) => {
            setSelectedCustomer(customer);
            setOpenModal(true);
          }}
          onDeleteData={() => fetchCustomers()}
          onChangeFilter={handleFilterChange}
          filterData={filterData}
          currentPage={page}
          itemsPerPage={filterData.limit}
          clientId={clientId}
        />

        <CustomPagination
          dataCount={dataCount}
          rowsPerPage={filterData.limit}
          page={page}
          setPage={setPage}
          setRowsPerPage={(e) => dispatch({ type: "UPDATE_LIMIT", payload: e })}
          disableNext={dataCount <= (page + 1) * filterData.limit}
        />
      </DashboardContainer>
    </>
  );
}
